<template>
  <div class="add">
    <header-bar :is-user="true"></header-bar>
    <user-head></user-head>
    <section class="main" v-if="userToken">
      <h1 class="title">发活动</h1>
      <el-form
        :model="postForm"
        :rules="rules"
        ref="postForm"
        label-width="120px"
        class="addForm"
      >
        <el-form-item label="封面图" prop="focusPic">
          <div class="avatar-uploader">
            <el-upload
              class="avatar-main"
              :action="baseUrl+'/upload/image'"
              :data="uploadImgParam"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
              accept=".png,.jpg,.jpeg"
              >
              <img v-if="postForm.focusPic" :src="postForm.focusPic" class="avatar"/>
              <div class="upload-tips" v-else>
                <p>
                  <i class="el-icon-plus avatar-uploader-icon"></i><br />上传图片
                </p>
                <p class="upload-des">图片大小不超过2M，格式为png、jpg、jpeg</p>
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="postForm.title" placeholder="请输入标题，标题长度50个字以内" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="活动时间" prop="activeTime">
          <el-date-picker
            v-model="postForm.activeTime"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            range-separator=""
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报名截止时间" prop="closeTime">
          <el-date-picker
            v-model="postForm.closeTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            placeholder="请选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动地点" prop="address">
          <el-input
            v-model="postForm.address"
            placeholder="请填写详细地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="参与人数" prop="peopleNum">
          <el-input v-model="postForm.peopleNum" type="number"></el-input>
        </el-form-item>
        <el-form-item label="版块" prop="channelId">
          <el-select v-model="postForm.channelId" placeholder="请选择版块">
            <el-option
              v-for="item in channelDataList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="正文" prop="content">
          <!-- <vue-ueditor-wrap
            v-model="postForm.content"
            :config="myConfig"
          ></vue-ueditor-wrap> -->
          <editor-bar v-model="detail" :isClear="isClear" @change="change"></editor-bar>
        </el-form-item>
        <el-form-item class="form-center">
          <el-button v-if="isLoading" type="primary" @click="submitForm('postForm')" class="play-btn" disabled>发布</el-button>
          <el-button v-else type="primary" @click="submitForm('postForm')" class="play-btn">发布</el-button>
          <el-button @click="resetForm('postForm')" class="cancel-btn">重置</el-button>
          <el-button @click="addDraft"  type="warning" plain>保存为草稿</el-button>
        </el-form-item>
      </el-form>
    </section>
    <section class="main" v-else>
      <h1 class="tips">请先登录！</h1>
      <div class="login">
        <el-button type="primary" @click="$router.push({path:'/login'})">去登录</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderBar from "@/components/Header.vue";
import UserHead from "@/components/UserHead.vue";
// import VueUeditorWrap from "vue-ueditor-wrap";
import EditorBar from '@/components/Editor.vue';
export default {
  name: "AddActivity",
  components: {
    HeaderBar,
    UserHead,
    EditorBar
    // VueUeditorWrap
  },
  data() {
    return {
      userToken: localStorage.getItem("UserToken"),
      addTypeFlag: false,
      channelDataList: [],
      postForm: {
        focusPic: "",
        title: "",
        activeTime: "",
        closeTime: "",
        address: "",
        peopleNum: null,
        content: "",
        channelId:""
      },
      rules: {
        focusPic:[{ required: true, message: "请上传封面图", trigger: "change" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        activeTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        closeTime: [{ required: true, message: "请选择报名截止时间", trigger: "change" }],
        address: [{ required: true, message: "请输入活动地点", trigger: "blur" }],
        peopleNum: [{ required: true, message: "请输入参与人数", trigger: "blur" }],
        content: [{ required: true, message: "请完善正文", trigger: "blur" }],
        channelId: [{ required: true, message: "请选择版块", trigger: "change" }]
      },
      // myConfig: {
      //   UEDITOR_HOME_URL: "/static/ue/"
      // },
      isClear: false,
      detail:"",
      baseUrl:(window.location.host.indexOf('bbs.dahe.cn')>-1) ? "https://bbs-api.dahe.cn" : "https://bbs-api.dahe.cn",
      uploadImgParam:{
        water:0
      },
      isLoading: false
    };
  },
  methods: {
    getChannels() {
      this.$api
        .channelList({
          type: 1
        })
        .then(res => {
          this.channelDataList = res.data.data;
        });
    },
    //上传图片
    handleAvatarSuccess(res, file) {
     this.postForm.focusPic = res.data;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    submitForm(formName) {
      let _this = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isLoading = true;
          this.postForm.beginTime = this.postForm.activeTime[0]
          this.postForm.endTime = this.postForm.activeTime[1]
          this.$api.addActivity(this.postForm).then(res => {
            window.localStorage.removeItem("formDataActivity")
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 2000,
              onClose: function(){
                _this.$router.push('/user/personal/'+ JSON.parse(localStorage.getItem("UserInfo")).id)
              }
            });
            this.$refs[formName].resetFields();
          });
          setTimeout(() => {
            this.isLoading = false;
          }, 2000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    addDraft(){
      window.localStorage.setItem("formDataActivity",JSON.stringify(this.postForm))
      this.$message({
          message: '已保存为草稿',
          type: 'success'
      });
    },
    change(val) {
      this.postForm.content = val
    }
  },
  created() {
    this.getChannels();
    this.postForm = JSON.parse(window.localStorage.getItem("formDataActivity"))||this.postForm;
  }
};
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 10px auto;
  background: #fff;
  padding: 26px;
  .title {
    font-size: 18px;
    line-height: 1;
    color: #121212;
    border-left: 4px solid #317DFF;
    padding-left: 10px;
  }
  .tips{
    font-size: 18px;
    line-height: 1;
    color: #121212;
    text-align: center;
    margin-top: 100px;
  }
  .login{
    text-align: center;
    margin-top: 20px;
    margin-bottom: 100px;
    .el-button{
      width: 100px;
      height: 40px;
      background: #317DFF; 
    }
  }
  .addForm {
    margin-top: 20px;
    margin-right: 60px;
    .el-select {
      display: block;
    }
    .el-date-editor{
      width: 100%;
    }
    .avatar-uploader {
      width: 300px;
      height: 180px;
      border-radius: 3px;
      border: 1px solid #E5E5E5;
      padding: 9px;
      .avatar-main{
        background: #F7F7F7;
        height: 100%;
        border-radius: 3px;
        position: relative;
        text-align: center;
        img{
          width: 280px;
          height: 160px;
        }
      }
      .upload-tips {
        text-align: center;
        color: #317DFF;
        line-height: 1.8;
        padding-top: 30px;
        i {
          font-size: 22px;
          font-weight: bold;
        }
        p.upload-des {
          font-size: 12px;
          color: #666666;
          margin-top: 7px;
        }
      }
    }
    .form-center {
      text-align: center;
      .play-btn {
        width: 128px;
        height: 40px;
        background: #317DFF;
        border-radius: 4px;
        border: none;
      }
      .cancel-btn {
        width: 128px;
        height: 40px;
        background: #dddddd;
        border-radius: 4px;
        margin-left: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/addActivity.vue